import React, { useState, useEffect, useRef } from 'react';
import { NavLink } from 'react-router-dom';
const CryptoWithdrawForm = ({
   selectedCrypto,
   amount,
   cryptoAmount,
   address: propAddress, // Renombramos para evitar conflicto
   handleAmountChange,
   handleBack,
   isSendOperation = false
}) => {
   // Añadir una referencia al input
   const usdInputRef = useRef(null);
   // Estados existentes
   const [showConfirmation, setShowConfirmation] = useState(false);
   const [orderCompleted, setOrderCompleted] = useState(false);
   const [fee, setFee] = useState('');
   const [total, setTotal] = useState('');
   const [usdAmount, setUsdAmount] = useState('');
   const [isConverting, setIsConverting] = useState(false);
   const [localCryptoAmount, setLocalCryptoAmount] = useState(cryptoAmount || '0.00000000');
   const [conversionError, setConversionError] = useState(null);
   const [showCryptoInput, setShowCryptoInput] = useState(false);
   // Añadir estado para la dirección ingresada por el usuario
   const [address, setAddress] = useState('');
   // Agregar un nuevo estado para controlar si se muestra en USD o cripto
   const [showInUsd, setShowInUsd] = useState(false);
   // Nuevos estados para manejar la transacción
   const [isLoading, setIsLoading] = useState(false);
   const [transactionHash, setTransactionHash] = useState('');
   // Manejar cambios en el campo de dirección
   const handleAddressChange = (e) => {
      setAddress(e.target.value);
   };
   // Convertir USD a criptomoneda seleccionada
   const convertUsdToCrypto = async (value) => {
      // Reiniciar el estado
      setIsConverting(true);
      setConversionError(null);
      // Para fines de prueba y depuración, asignar un valor hardcodeado
      console.log(`DEBUG: Iniciando conversión de ${value} USD a ${selectedCrypto.code}`);
      try {
         const jwt = localStorage.getItem('jwt');
         if (!jwt) {
            throw new Error('No authentication token found');
         }
         // Registrar los datos enviados a la API
         const requestData = {
            amount: parseFloat(value),
            originCurrency: 'USD',
            resultCurrency: selectedCrypto.code
         };
         console.log("Enviando solicitud a la API:", requestData);
         // Hacer la solicitud a la API
         const response = await fetch('https://pt-api.digit-a.net/api/withdraw/convert', {
            method: 'POST',
            headers: {
               'Authorization': `Bearer ${jwt}`,
               'Content-Type': 'application/json'
            },
            body: JSON.stringify(requestData)
         });
         console.log("Respuesta API status:", response.status);
         // Verificar si la respuesta es OK
         if (!response.ok) {
            let errorText = '';
            try {
               errorText = await response.text();
            } catch (e) {
               errorText = 'No se pudo leer el cuerpo de la respuesta';
            }
            console.error('API Response Error:', errorText);
            throw new Error(`Error: ${response.status} - ${response.statusText}`);
         }
         // Intenta procesar la respuesta
         let data;
         try {
            const data = await response.json();
            console.log('RESPUESTA API COMPLETA:', JSON.stringify(data, null, 2));
            const convertedAmount = data.result;

            const formattedAmount = parseFloat(convertedAmount).toFixed(6);
            setLocalCryptoAmount(formattedAmount); // Todavía actualizamos el estado para la UI

            return formattedAmount;
         } catch (e) {
            console.error('Error al parsear JSON:', e);
            return null
            // throw new Error('Error al procesar la respuesta del servidor');
         }
         // SOLUCIÓN TEMPORAL: Si la API no está funcionando, usar un valor de prueba
         // Esto es para que puedas seguir probando el flujo de la aplicación
         let convertedAmount;
         // Intentar extraer el valor de diferentes ubicaciones posibles en la respuesta
         if (data) {
            convertedAmount =
               (data.result !== undefined) ? data.result :
                  (data.convertedAmount !== undefined) ? data.convertedAmount :
                     (data.converted_amount !== undefined) ? data.converted_amount :
                        (data.data && data.data.convertedAmount !== undefined) ? data.data.convertedAmount :
                           null;
            console.log('Valor encontrado en la respuesta:', convertedAmount);
         }
         // Si no se puede encontrar en la estructura esperada, implementar una solución de respaldo
         if (convertedAmount === null || convertedAmount === undefined) {
            console.warn('No se pudo encontrar el valor convertido en la respuesta. Usando valor de respaldo.');
            // Generar un valor aproximado basado en tasas de ejemplo
            // Estos son valores ficticios para pruebas:
            const tasas = {
               'BTC': 0.00004,  // 1 USD ≈ 0.00004 BTC
               'ETH': 0.0005,   // 1 USD ≈ 0.0005 ETH
               'USDT': 1,       // 1 USD ≈ 1 USDT
               'USDC': 1        // 1 USD ≈ 1 USDC
            };
            // Usar la tasa correspondiente o un valor por defecto
            const tasa = tasas[selectedCrypto.code] || 0.0001;
            convertedAmount = parseFloat(value) * tasa;
            console.log(`Usando conversión de respaldo: ${value} USD = ${convertedAmount} ${selectedCrypto.code}`);
         }
         // Formatear y guardar el resultado
         const formattedAmount = parseFloat(convertedAmount).toFixed(6);
         console.log(`Conversión completada: ${value} USD = ${formattedAmount} ${selectedCrypto.code}`);
         setLocalCryptoAmount(formattedAmount);
      } catch (err) {
         console.error('Error en la conversión:', err);
         setConversionError(err.message || 'Error al convertir la moneda');
         // IMPORTANTE: Para no bloquear el flujo, asignar un valor de respaldo en caso de error
         // Esto permite que el usuario pueda continuar a pesar del error de API
         const tasas = {
            'BTC': 0.00004,  // 1 USD ≈ 0.00004 BTC
            'ETH': 0.0005,   // 1 USD ≈ 0.0005 ETH
            'USDT': 1,       // 1 USD ≈ 1 USDT
            'USDC': 1        // 1 USD ≈ 1 USDC
         };
         const tasa = tasas[selectedCrypto.code] || 0.0001;
         const respaldoAmount = (parseFloat(value) * tasa).toFixed(6);
         console.log(`Error en API, usando valor de respaldo: ${respaldoAmount}`);
         setLocalCryptoAmount(respaldoAmount);
      } finally {
         setIsConverting(false);
      }
   };
   // Modificar la implementación de manejo de entrada y conversión
   // Eliminar el useEffect con debounce ya que ahora la conversión será manual
   // Modificar la función handleUsdInputChange para realizar una conversión básica en tiempo real
   const handleUsdInputChange = (e) => {
      // Permitir solo números y un punto decimal
      const value = e.target.value.replace(/[^0-9.]/g, '');
      // Evitar múltiples puntos decimales
      const parts = value.split('.');
      const formatted = parts[0] + (parts.length > 1 ? '.' + parts[1] : '');
      // Actualizar el estado USD
      setUsdAmount(formatted);
      // Realizar una conversión aproximada para habilitar el botón Continue
      // sin necesidad de hacer clic en el botón de conversión
      if (formatted && parseFloat(formatted) > 0) {
         // Usar tasas de conversión básicas
         const tasas = {
            'BTC': 0.00004,  // 1 USD ≈ 0.00004 BTC
            'ETH': 0.0005,   // 1 USD ≈ 0.0005 ETH
            'USDT': 1,       // 1 USD ≈ 1 USDT
            'USDC': 1,       // 1 USD ≈ 1 USDC
            'MATIC': 1.25    // 1 USD ≈ 1.25 MATIC
         };
         // Usar la tasa correspondiente o un valor por defecto
         const tasa = tasas[selectedCrypto.code] || 0.0001;
         const estimatedAmount = (parseFloat(formatted) * tasa).toFixed(6);
         // Actualizar el monto en cripto sin cambiar la visualización
         setLocalCryptoAmount(estimatedAmount);
      } else {
         // Si no hay un valor válido, establecer el monto en cripto a cero
         setLocalCryptoAmount('0.00000000');
      }
   };
   // Agregar una función para manejar el clic en el botón de conversión
   const handleConvertClick = () => {
      // Verificar que haya un valor válido para convertir
      if (usdAmount && parseFloat(usdAmount) > 0) {
         // Mostrar un mensaje mientras se convierte
         console.log("Convirtiendo:", usdAmount, "USD a", selectedCrypto.code);
         // Llamar a la función de conversión con el valor actual
         convertUsdToCrypto(usdAmount);
         // Alternar la visualización después de completar la conversión
         setTimeout(() => {
            if (!showCryptoInput) {
               // Si actualmente muestra USD, cambiar a crypto
               document.getElementById('usd_input_container').style.display = 'none';
               document.getElementById('crypto_input_container').style.display = 'flex';
               setShowCryptoInput(true);
            } else {
               // Si actualmente muestra crypto, cambiar a USD
               document.getElementById('crypto_input_container').style.display = 'none';
               document.getElementById('usd_input_container').style.display = 'flex';
               setShowCryptoInput(false);
            }
         }, 500); // Aumentar el tiempo para asegurar que la conversión se complete
      } else {
         // Mostrar un error si no hay un valor válido
         setConversionError("Por favor ingresa un monto válido en USD");
      }
   };
   // Calcular comisión y total al entrar en la pantalla de confirmación
   // Modificar handleContinueClick para validar que el monto no sea cero
   const handleContinueClick = async () => {
      console.log("== INICIANDO CONTINUE ==");
      console.log("USD Amount:", usdAmount);
      console.log("Crypto Amount:", localCryptoAmount);
      console.log("Address:", address);

      // Validar que haya una dirección
      if (!address || address.trim() === '') {
         setConversionError("Please enter a valid destination address");
         return;
      }

      // Validar que haya un monto en USD
      if (!usdAmount || isNaN(parseFloat(usdAmount)) || parseFloat(usdAmount) <= 0) {
         setConversionError("Please enter a valid amount in USD");
         return;
      }

      // Nueva validación específica para montos cero o muy pequeños
      if (parseFloat(usdAmount) === 0 || parseFloat(localCryptoAmount) === 0) {
         setConversionError("Amount cannot be zero. Please enter a valid amount to send.");
         return;
      }

      try {
         // Siempre hacer una conversión fresca al hacer click en continue
         console.log("Realizando conversión en Continue...");
         const convertedAmount = await convertUsdToCrypto(usdAmount);

         // Si la conversión falló, detente
         if (convertedAmount === null || parseFloat(convertedAmount) <= 0) {
            setConversionError("The converted amount is too small or invalid.");
            return;
         }

         // Llama a la verificación de balance PASÁNDOLE el resultado
         const hasSufficientBalance = await checkBalance(convertedAmount);

         // Si el balance es insuficiente, detente
         if (!hasSufficientBalance) {
            return;
         }

         //  Si todo está bien, calcula las comisiones y muestra la confirmación
         const cryptoValue = parseFloat(convertedAmount);
         const feeValue = (cryptoValue * 0.012).toFixed(6);
         setFee(feeValue);
         setTotal((cryptoValue + parseFloat(feeValue)).toFixed(6));

         setShowConfirmation(true);

      } catch (error) {
         console.error("Error en handleContinueClick:", error);
         setConversionError("Error performing the conversion. Please try again.");
      }
   };
   // Añadir una nueva función para verificar el saldo antes de continuar
   const checkBalance = async (amountToCheck) => {
      try {
         setIsLoading(true);
         console.log("Verificando saldo para", selectedCrypto.code);

         const jwt = localStorage.getItem('jwt');
         if (!jwt) {
            throw new Error('No authentication token found');
         }

         // Llamar al endpoint para obtener el saldo
         const response = await fetch(`https://pt-api.digit-a.net/api/wallets/balance/${selectedCrypto.code}`, {
            method: 'GET',
            headers: {
               'Authorization': `Bearer ${jwt}`,
               'Content-Type': 'application/json'
            }
         });

         if (!response.ok) {
            throw new Error(`Error: ${response.status} - ${response.statusText}`);
         }

         const data = await response.json();
         console.log("Balance response:", data);

         // Verificar si el saldo es suficiente
         const balance = parseFloat(data.amount || 0);
         const amount = parseFloat(amountToCheck);
         const totalNeeded = amount + (amount * 0.012); // Amount + fee (1.2%)

         console.log("Balance actual:", balance, selectedCrypto.code);
         console.log("Total requerido:", totalNeeded, selectedCrypto.code);

         if (balance < totalNeeded) {
            // No hay suficiente saldo
            setConversionError(`Insufficient balance. You have ${balance.toFixed(6)} ${selectedCrypto.code} but need ${totalNeeded.toFixed(6)} ${selectedCrypto.code} (including fees).`);
            return false;
         }

         // Si hay suficiente saldo, limpiar cualquier error previo
         setConversionError(null);
         return true;
      } catch (error) {
         console.error("Error checking balance:", error);
         setConversionError(error.message || "Error checking your balance. Please try again.");
         return false;
      } finally {
         setIsLoading(false);
      }
   };
   // Manejar la confirmación final
   const handleConfirmClick = async () => {
      try {
         // Mostrar estado de carga
         setIsLoading(true);

         const jwt = localStorage.getItem('jwt');
         if (!jwt) {
            throw new Error('No authentication token found');
         }

         // Preparar los datos para la solicitud de envío
         const requestData = {
            currencyType: selectedCrypto.code,
            toAddress: address,
            amount: parseFloat(localCryptoAmount)
         };

         console.log("Sending transaction request:", requestData);

         // Hacer la solicitud a la API de envío
         const response = await fetch('https://pt-api.digit-a.net/api/withdraw/send', {
            method: 'POST',
            headers: {
               'Authorization': `Bearer ${jwt}`,
               'Content-Type': 'application/json'
            },
            body: JSON.stringify(requestData)
         });

         console.log("API response status:", response.status);

         // Verificar si la respuesta es OK
         if (!response.ok) {
            let errorText = '';
            try {
               errorText = await response.text();
            } catch (e) {
               errorText = 'Could not read response body';
            }
            console.error('API Response Error:', errorText);
            throw new Error(`Error: ${response.status} - ${response.statusText}`);
         }

         // Procesar la respuesta
         const data = await response.json();
         console.log('TRANSACTION RESPONSE:', JSON.stringify(data, null, 2));

         // Verificar si la transacción fue exitosa
         if (data.success) {
            // Guardar el hash de la transacción para mostrarlo en la pantalla de éxito
            const txHash = data.data?.hash || 'Transaction submitted';
            console.log("Transaction hash:", txHash);

            // Actualizar el estado para mostrar la pantalla de éxito
            setTransactionHash(txHash);
            setOrderCompleted(true);
         } else {
            throw new Error(data.message || 'Transaction failed');
         }
      } catch (error) {
         console.error("Error in handleConfirmClick:", error);
         setConversionError(error.message || "Error processing the transaction. Please try again.");
      } finally {
         setIsLoading(false);
      }
   };
   // Formatear la dirección para mostrarla parcialmente
   const formatAddress = (addr) => {
      if (addr && addr.length > 12) {
         return `${addr.substring(0, 6)}...${addr.substring(addr.length - 6)}`;
      }
      return addr || '';
   };
   // Formatear monto USD
   const formatUsdAmount = (value) => {
      if (!value) return '$0.00';
      return `$${parseFloat(value).toFixed(2)}`;
   };
   // Agregar función para alternar entre mostrar valores en USD o cripto
   const toggleCurrencyDisplay = () => {
      setShowInUsd(!showInUsd);
   };
   // Añadir función para copiar al portapapeles
   const copyAddressToClipboard = () => {
      // Copiar la dirección completa, no la versión abreviada
      navigator.clipboard.writeText(address)
         .then(() => {
            // Opcional: mostrar alguna indicación de éxito
            console.log("Dirección copiada al portapapeles");
            // Puedes mostrar un mensaje temporal de éxito
            const copyIndicator = document.createElement('span');
            copyIndicator.textContent = "";
            copyIndicator.className = "copy-success-indicator";
            copyIndicator.style.color = "green";
            copyIndicator.style.fontSize = "12px";
            copyIndicator.style.position = "absolute";
            copyIndicator.style.right = "30px";
            copyIndicator.style.opacity = "1";
            copyIndicator.style.transition = "opacity 1s ease-in-out";
            const addressContainer = document.querySelector(".address-container");
            addressContainer.appendChild(copyIndicator);
            // Eliminar el indicador después de unos segundos
            setTimeout(() => {
               copyIndicator.style.opacity = "0";
               setTimeout(() => {
                  addressContainer.removeChild(copyIndicator);
               }, 1000);
            }, 2000);
         })
         .catch(err => {
            console.error('Error al copiar al portapapeles: ', err);
         });
   };
   // Añadir esto antes del return para tener una lógica de habilitación más clara
   const isContinueDisabled =
      isConverting ||
      !usdAmount ||
      parseFloat(usdAmount) <= 0 ||
      !address ||
      address.trim() === '' ||
      parseFloat(localCryptoAmount) === 0;
   return (
      <div className="withdraw-crypto-form">
         {orderCompleted ? (
            // Pantalla de éxito después de confirmar
            <div className='ppt_deposit_item text-center'>
               <img
                  src={process.env.PUBLIC_URL + '/assets/img/icon_check.svg'}
                  alt=""
                  style={{ width: '100px' }}
                  className="d-block mb-2 mx-auto"
               />
               <p className="col-lg-10 mx-lg-auto mb-2">
                  <strong className='d-block mb-2'>Order confirmed!</strong>
                  Thank you for your transaction request. Your transaction has been submitted to the blockchain network and will be processed shortly. Please allow some time for the transaction to be confirmed.
               </p>
               <div className='ppt_deposit_item gap-1 py-3' style={{ backgroundColor: '#E0E0E0' }}>
                  <strong className='d-block'>Order details</strong>
                  <small>
                     <strong>Amount:</strong> {localCryptoAmount} {selectedCrypto.code}<br />
                     <strong>Fee:</strong> {fee} {selectedCrypto.code}<br />
                     <strong>Total:</strong> {(parseFloat(localCryptoAmount) + parseFloat(fee)).toFixed(6)} {selectedCrypto.code}<br />
                     <strong>Address:</strong> {formatAddress(address)}<br />
                     <strong>Network:</strong> {selectedCrypto.name} <br />
                     {transactionHash && (
                        <>
                           <strong>Transaction ID:</strong> {formatAddress(transactionHash)}<br />
                           <span className="d-block mt-1">
                              <a
                                 href={`https://polygonscan.com/tx/${transactionHash}`}
                                 target="_blank"
                                 rel="noopener noreferrer"
                                 style={{ color: '#013220', textDecoration: 'underline' }}
                              >
                                 View on blockchain explorer
                              </a>
                           </span>
                        </>
                     )}
                  </small>
               </div>
               <div className="d-flex justify-content-center gap-3 pt-2">
                  <small><strong>For any inquiry on your order's status please contact sales at <NavLink className='t-anchor' to='tel:+18242585211'><u>+1 824 258 5211</u></NavLink> or use the <NavLink className='t-anchor' to=''><u>chat bot</u></NavLink>.</strong></small>
               </div>
            </div>
         ) : !showConfirmation ? (
            // Primera pantalla - Formulario de retiro/envío
            <>
               <h3 className="ppt_form_title mb-3 text-center">
                  {isSendOperation ? "Send" : "Withdraw"} {/* Cambiar el título según la operación */}
                  <img
                     src={process.env.PUBLIC_URL + selectedCrypto.image}
                     alt={selectedCrypto.name}
                     style={{ width: '28px', height: '28px', marginLeft: '8px', verticalAlign: 'middle' }}
                  />
               </h3>
               <div className="d-flex align-items-center  justify-content-center mb-3 position-relative">
                  <div className='d-flex flex-column'>
                     <div id='usd_input_container'>
                        <div className="position-relative d-flex align-items-center justify-content-end w-100 pe-4" style={{ height: '100px' }}>
                           <span className="position-relative" style={{ fontSize: '100px', left: '64px', lineHeight: '100%' }}>$</span>
                           <input
                              ref={usdInputRef}
                              className="ppt_big_amount origin"
                              style={{
                                 maxWidth: '342px',
                                 fontSize: '100px',
                                 lineHeight: '100%',
                                 backgroundColor: 'transparent',
                                 padding: '0 0 0 70px',
                                 border: '0',
                                 outline: 'none',
                              }}
                              value={usdAmount}
                              onChange={handleUsdInputChange}
                              placeholder="0.00"
                              type="text"
                              inputMode="decimal"
                              name='origin_amount'
                           />
                        </div>
                     </div>
                     {/* Input para mostrar el resultado de la conversión */}
                     <div id='crypto_input_container' style={{ display: 'none' }}>
                        <div className="position-relative w-100 pe-4">
                           <input
                              className='ppt_big_amount result text-end'
                              style={{
                                 maxWidth: '272px',
                                 fontSize: '52px',
                                 lineHeight: '100%',
                                 backgroundColor: 'transparent',
                                 padding: '0 10px 0 0',
                                 border: '0px',
                                 outline: 'none',
                              }}
                              value={`${localCryptoAmount}`}
                              // readOnly
                              placeholder={`0.00000000 ${selectedCrypto.code}`}
                           />
                           <span className="position-relative" style={{ fontSize: '30px' }}>{selectedCrypto.code}</span>
                        </div>
                     </div>
                  </div>
                  <div className="d-flex align-items-center flex-column justify-content-center">
                     <span
                        className="ppt_btn_convert_crypto pointer"
                        onClick={handleConvertClick}
                        style={{ cursor: 'pointer' }}
                     >
                        <svg width="53" height="52" viewBox="0 0 53 52" fill="none" xmlns="http://www.w3.org/2000/svg">
                           <g clipPath="url(#clip0_229_16618)">
                              <path d="M44.1498 16.8444C44.6388 17.2443 44.7105 17.9641 44.3109 18.4527L24.3491 42.8595L31.2539 42.1678C31.8824 42.1048 32.4422 42.5627 32.5049 43.191C32.5364 43.505 32.4376 43.8022 32.2526 44.0285C32.0675 44.2548 31.7958 44.4105 31.4817 44.442L21.8315 45.4088C21.203 45.4718 20.6432 45.0139 20.5805 44.3856L19.6137 34.7354C19.5507 34.1069 20.0086 33.5471 20.6369 33.4843C21.2651 33.4216 21.8252 33.8792 21.8879 34.5075L22.5796 41.4123L42.5414 17.0055C42.941 16.5169 43.6607 16.4444 44.1498 16.8444ZM30.9257 6.46133L21.2755 7.42814C20.647 7.4911 20.1891 8.05093 20.2523 8.67918C20.3154 9.30743 20.8751 9.76552 21.5033 9.70237L28.408 9.01063L8.4463 33.4174C8.04668 33.906 8.11838 34.6258 8.60743 35.0258C9.09648 35.4258 9.81618 35.3532 10.2158 34.8646L30.1775 10.4579L30.8693 17.3626C30.9323 17.9911 31.4921 18.4489 32.1203 18.3858C32.4344 18.3543 32.7061 18.1986 32.8912 17.9723C33.0762 17.746 33.175 17.4488 33.1435 17.1348L32.1767 7.48453C32.114 6.85624 31.5539 6.39819 30.9257 6.46133Z" fill="black" />
                           </g>
                           <defs>
                              <clipPath id="clip0_229_16618">
                                 <rect width="36.5755" height="36.5755" fill="white" transform="translate(0.644531 28.5132) rotate(-50.721)" />
                              </clipPath>
                           </defs>
                        </svg>
                     </span>
                     <b>
                        {/* Mostrar el código correcto según el estado */}
                        {!showCryptoInput ? (
                           <>
                              <span className="ppt_origin_code" style={{ display: 'none' }}>USD</span>
                              <span className="ppt_result_code">{selectedCrypto.code}</span>
                           </>
                        ) : (
                           <>
                              <span className="ppt_origin_code">USD</span>
                              <span className="ppt_result_code" style={{ display: 'none' }}>{selectedCrypto.code}</span>
                           </>
                        )}
                     </b>
                     {/* {isConverting && <small>(Convirtiendo...)</small>} */}
                  </div>
               </div>
               {conversionError && (
                  <div className="text-danger w-100 mb-4 d-block text-center">
                     {/* Error: {conversionError} */}
                     Insufficient balance. Please enter a valid amount.

                  </div>
               )}
               <div className="ppt_input_style mb-3">
                  <div className="d-flex flex-column flex-lg-row align-items-center mb-3 gap-1 gap-lg-3">
                     <label>Address</label>
                     <input
                        className="form-control"
                        value={address}
                        onChange={handleAddressChange}
                        placeholder={`Enter ${selectedCrypto.code} address`}
                     />
                  </div>
               </div>
               <p className="d-block col-lg-11 mx-lg-auto text-center">
                  <strong className="text-danger">
                     <img
                        src={process.env.PUBLIC_URL + '/assets/img/icon_warning_red.svg'}
                        alt=""
                        style={{ width: '14px', transform: 'translateY(-1px)' }}
                     /> Warning:
                  </strong> Use only an {selectedCrypto.code} address. Incorrect addresses will result in lost funds. Crypto transactions are final.
               </p>
               <button
                  className="ppt_btn_primary alt mt-3 py-3 mx-auto d-block"
                  onClick={handleContinueClick}
                  disabled={isContinueDisabled}
               >
                  Continue
               </button>
            </>
         ) : (
            // Segunda pantalla - Confirmación
            <div className="confirmation-screen">
               <div className="d-flex flex-column align-items-center mb-4">
                  <img
                     src={process.env.PUBLIC_URL + selectedCrypto.image}
                     alt={selectedCrypto.code}
                     style={{ width: '56px', height: '56px' }}
                     className="mb-2"
                  />
                  <h3 className="mb-2">{localCryptoAmount} {selectedCrypto.code}</h3>
                  {/* <small className="text-muted">≈ {formatUsdAmount(usdAmount)} USD</small> */}
               </div>
               <div className="confirmation-details mb-4">
                  <div className="row py-2">
                     <div className="col-6 text-start"></div>
                     <div
                        className="col-6 text-end d-flex align-items-center justify-content-end gap-1 pointer"
                        id="ppt_show_usd"
                        onClick={toggleCurrencyDisplay}
                     >
                        <svg width="24" height="24" viewBox="0 0 53 52" fill="none" xmlns="http://www.w3.org/2000/svg">
                           <g clipPath="url(#clip0_229_16618)">
                              <path d="M44.1498 16.8444C44.6388 17.2443 44.7105 17.9641 44.3109 18.4527L24.3491 42.8595L31.2539 42.1678C31.8824 42.1048 32.4422 42.5627 32.5049 43.191C32.5364 43.505 32.4376 43.8022 32.2526 44.0285C32.0675 44.2548 31.7958 44.4105 31.4817 44.442L21.8315 45.4088C21.203 45.4718 20.6432 45.0139 20.5805 44.3856L19.6137 34.7354C19.5507 34.1069 20.0086 33.5471 20.6369 33.4843C21.2651 33.4216 21.8252 33.8792 21.8879 34.5075L22.5796 41.4123L42.5414 17.0055C42.941 16.5169 43.6607 16.4444 44.1498 16.8444ZM30.9257 6.46133L21.2755 7.42814C20.647 7.4911 20.1891 8.05093 20.2523 8.67918C20.3154 9.30743 20.8751 9.76552 21.5033 9.70237L28.408 9.01063L8.4463 33.4174C8.04668 33.906 8.11838 34.6258 8.60743 35.0258C9.09648 35.4258 9.81618 35.3532 10.2158 34.8646L30.1775 10.4579L30.8693 17.3626C30.9323 17.9911 31.4921 18.4489 32.1203 18.3858C32.4344 18.3543 32.7061 18.1986 32.8912 17.9723C33.0762 17.746 33.175 17.4488 33.1435 17.1348L32.1767 7.48453C32.114 6.85624 31.5539 6.39819 30.9257 6.46133Z" fill="black" />
                           </g>
                           <defs>
                              <clipPath id="clip0_229_16618">
                                 <rect width="36.5755" height="36.5755" fill="white" transform="translate(0.644531 28.5132) rotate(-50.721)" />
                              </clipPath>
                           </defs>
                        </svg>
                        <b>{showInUsd ? "Show in " + selectedCrypto.code : "Show in USD"}</b>
                     </div>
                  </div>
                  <div className="row py-2">
                     <div className="col-6 text-start"><b>Amount</b></div>
                     <div className="col-6 text-end">
                        {showInUsd
                           ? formatUsdAmount(usdAmount)
                           : `${localCryptoAmount} ${selectedCrypto.code}`
                        }
                     </div>
                  </div>
                  <div className="row py-2 border-bottom">
                     <div className="col-6 text-start"><b>Fee</b></div>
                     <div className="col-6 text-end">
                        {showInUsd
                           ? formatUsdAmount(parseFloat(usdAmount) * 0.012)
                           : `${fee} ${selectedCrypto.code}`
                        }
                     </div>
                  </div>
                  <div className="row py-2 font-weight-bold">
                     <div className="col-6 text-start"><b>Total</b></div>
                     <div className="col-6 text-end">
                        {showInUsd
                           ? formatUsdAmount(parseFloat(usdAmount) * 1.012)
                           // Calcular el total directamente como la suma de amount y fee
                           : `${(parseFloat(localCryptoAmount) + parseFloat(fee)).toFixed(6)} ${selectedCrypto.code}`
                        }
                     </div>
                  </div>
               </div>
               <div className="mb-4">
                  <div className="row py-2">
                     <div className="col-6 text-start"><b>Address</b></div>
                     <div className="col-6 text-end d-flex align-items-center justify-content-end gap-2 address-container position-relative">
                        <span
                           onClick={copyAddressToClipboard}
                           style={{ cursor: 'pointer' }}
                           title="Copiar dirección completa"
                        >
                           <svg width="18" height="18" viewBox="0 0 11 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M7.47212 2.44849H1.08593C0.486701 2.44849 0 2.9445 0 3.55519V12.8933C0 13.504 0.486701 14 1.08593 14H7.47212C8.07136 14 8.55806 13.504 8.55806 12.8933V3.55519C8.55524 2.9445 8.06854 2.44849 7.47212 2.44849ZM7.79565 12.8904C7.79565 13.0739 7.64936 13.223 7.46931 13.223H1.08312C0.903069 13.223 0.756778 13.0739 0.756778 12.8904V3.55519C0.756778 3.3717 0.903069 3.22261 1.08312 3.22261H7.46931C7.64936 3.22261 7.79565 3.3717 7.79565 3.55519V12.8904Z" fill="#011D1B" />
                              <path d="M9.91407 0H3.52788C2.92864 0 2.44194 0.496007 2.44194 1.1067C2.44194 1.32173 2.61074 1.49375 2.82174 1.49375C3.03274 1.49375 3.20153 1.32173 3.20153 1.1067C3.20153 0.923203 3.34783 0.774114 3.52788 0.774114H9.91407C10.0941 0.774114 10.2404 0.923203 10.2404 1.1067V10.4448C10.2404 10.6283 10.0941 10.7774 9.91407 10.7774C9.70307 10.7774 9.53427 10.9494 9.53427 11.1644C9.53427 11.3795 9.70307 11.5515 9.91407 11.5515C10.5133 11.5515 11 11.0555 11 10.4448V1.1067C11 0.496007 10.5133 0 9.91407 0Z" fill="#011D1B" />
                           </svg>
                        </span>
                        <span>{formatAddress(address)}</span>
                     </div>
                  </div>
                  <div className="row py-2">
                     <div className="col-6 text-start"><b>Withdraw</b></div>
                     <div className="col-6 text-end">{selectedCrypto.name}</div>
                  </div>
               </div>
               <p className="d-block col-lg-11 mx-lg-auto text-center">
                  <strong className="text-danger">
                     <img
                        src={process.env.PUBLIC_URL + '/assets/img/icon_warning_red.svg'}
                        alt=""
                        style={{ width: '14px', transform: 'translateY(-1px)' }}
                     /> Warning:
                  </strong> Use only an {selectedCrypto.code} address. Incorrect addresses will result in lost funds. Crypto transactions are final.
               </p>
               <button
                  className="ppt_btn_primary alt mt-3 py-3 mx-auto d-block"
                  style={{ backgroundColor: '#E4DC00' }}
                  onClick={handleConfirmClick}
                  disabled={isLoading}
               >
                  {isLoading ? "Processing..." : (isSendOperation ? "Confirm Send" : "Confirm")}
               </button>
            </div>
         )}
      </div>
   );
};
export default CryptoWithdrawForm;